import type { PropsWithChildren } from 'react';

import { Container } from '~shared/ui/layout';

import { Typography } from '@breezeventures/ui-kit/typography';

export const OrdersLayout = ({
  title,
  children,
}: { title: React.ReactNode } & PropsWithChildren) => {
  return (
    <Container>
      <div
        className={`
          box-border min-h-full w-full pt-6 pb-page-bottom-mobile
          lg:pt-10 lg:pb-16
        `}
      >
        {typeof title === 'string' ? (
          <Typography.Title size="s" tag="h2">
            {title}
          </Typography.Title>
        ) : (
          title
        )}
        {children}
      </div>
    </Container>
  );
};
